import type { CityConfig } from "../city-template/types";

export const bellinghamConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — WA Dept of Health Vital Records", href: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", description: "Official Washington vital records office in Tumwater" },
    { label: "Marriage Licenses — Whatcom County Auditor", href: "https://www.whatcomcounty.us/", description: "Whatcom County Auditor — marriage license issuance" },
    { label: "Divorce Records — Whatcom County Clerk", href: "https://www.whatcomcounty.us/", description: "Whatcom County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of WA DOH for online vital record orders" },
  ],
  city: "Bellingham",
  state: "Washington",
  stateAbbr: "WA",
  slug: "bellingham",
  route: "/cities/bellingham",
  title: "Emergency Passport Bellingham WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bellingham, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Bellingham, Ferndale, Lynden, and all Whatcom County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Bellingham, WA",
  heroSubtitle: "Bellingham travelers — from Western Washington University students to Canadian border commuters to Whatcom County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of northwest Washington and the Peace Arch border region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Bellingham%20Washington%20with%20Bellingham%20Bay%20and%20the%20San%20Juan%20Islands%20in%20the%20distance%2C%20Mount%20Baker%20snow-capped%20peak%20dominating%20the%20skyline%2C%20downtown%20Bellingham%20with%20historic%20brick%20buildings%20and%20Fairhaven%20district%2C%20Western%20Washington%20University%20campus%20on%20the%20hillside%2C%20marina%20with%20sailboats%2C%20lush%20Pacific%20Northwest%20evergreen%20landscape%2C%20warm%20golden%20afternoon%20sunlight%20over%20the%20bay%2C%20maritime%20college%20town%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=bellingham-hero-001&orientation=landscape",
  heroImageAlt: "Bellingham Washington with Bellingham Bay and Mount Baker backdrop",
  geoPosition: "48.7484;-122.4787",
  geoPlacename: "Bellingham, Washington",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "Approximately 90 miles south of Bellingham via I-5",
  },
  nearbyCitiesZips: [
    { name: "Bellingham", zips: "98225, 98226, 98227, 98228, 98229" },
    { name: "Ferndale", zips: "98248" },
    { name: "Lynden", zips: "98264" },
    { name: "Blaine", zips: "98230" },
    { name: "Birch Bay", zips: "98230" },
    { name: "Everson", zips: "98247" },
    { name: "Nooksack", zips: "98276" },
    { name: "Sumas", zips: "98295" },
    { name: "Custer", zips: "98240" },
    { name: "Point Roberts", zips: "98281" },
    { name: "Lummi Island", zips: "98262" },
    { name: "Sudden Valley", zips: "98229" },
    { name: "Geneva", zips: "98229" },
    { name: "Acme", zips: "98220" },
    { name: "Deming", zips: "98244" },
    { name: "Glacier", zips: "98244" },
    { name: "Maple Falls", zips: "98266" },
    { name: "Burlington", zips: "98233" },
    { name: "Mount Vernon", zips: "98273, 98274" },
    { name: "Anacortes", zips: "98221" },
    { name: "La Conner", zips: "98257" },
    { name: "Sedro-Woolley", zips: "98284" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — I-5 corridor service covering all of Northwest Washington" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Border & Cross-Border Expert", desc: "Serving US-Canada border residents at Peace Arch, Sumas, and Point Roberts crossings" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Whatcom County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Emergency passport help in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Urgent passport services in Everett, WA", route: "/cities/everett" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bellingham, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 90 minutes south via I-5. Bellingham residents can ship from any UPS or FedEx in Whatcom County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Bellingham, Ferndale, Lynden, Blaine, Birch Bay, Everson, Nooksack, Sumas, Point Roberts, Lummi Island, and all of Whatcom County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Bellingham and Whatcom County. From Western Washington University on the hillside overlooking the bay to the historic Fairhaven district, from the Canadian border at Peace Arch to the Mount Baker foothills — we serve all of Bellingham and the northwest corner of Washington.",
  nearbyCitiesIntro: "We serve Bellingham and all nearby communities including Ferndale, Lynden, Blaine, Birch Bay, Everson, Nooksack, Sumas, Point Roberts, and Lummi Island. We also serve Burlington, Mount Vernon, Anacortes, and Skagit County. Our courier service reaches all of northwest Washington.",
  howItWorksIntro: "Most Bellingham travelers complete everything online and ship documents overnight. No need to drive 90+ minutes south on I-5 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Bellingham is a unique border community with Western Washington University, Peace Arch crossing, and significant travel from both US and Canadian residents. Here are the most common passport mistakes we see from Whatcom County travelers.",
  testimonialsIntro: "Bellingham travelers — from WWU students to border commuters to Whatcom County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Bellingham, WA? Here are the most common ones we hear from Northwest Washington travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 90+ minutes to Seattle on I-5", "Parking and traffic in downtown Seattle"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — I-5 corridor courier", "No 90-minute I-5 drive or downtown parking hassle", "Perfect for WWU students and border commuters", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — I-5 corridor courier", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bellingham travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for WWU study abroad, border community travel, and Whatcom County family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — I-5 corridor courier", "WWU student and border commuter travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bellingham adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Whatcom County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Bellingham residents and families — including WWU students, Canadian border commuters, and Whatcom County residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Bellingham residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Bellingham and Whatcom County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Bellingham and Whatcom County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bellingham WA", description: "Urgent passport processing for Bellingham Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Bellingham WA", description: "Fast passport renewal for Bellingham Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Bellingham WA", description: "New passport application services for Bellingham Washington residents applying for their first passport." },
    { name: "Child Passport Bellingham WA", description: "Minor passport services for Bellingham Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Bellingham, WA",
      rating: 5,
      text: "WWU study abroad program in Spain with 7 days notice and my passport was expired. Fast Passport Center had my renewed passport in 3 days. I shipped from the UPS Store on Bakerview Road and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "John & Maria D.",
      location: "Ferndale, WA",
      rating: 5,
      text: "Family trip to Vancouver BC with 8 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 4 days. We shipped from FedEx in Bellingham and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom L.",
      location: "Lynden, WA",
      rating: 5,
      text: "Business trip to Amsterdam with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Not having to drive to Seattle from Lynden was incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Emily R.",
      location: "Blaine, WA",
      rating: 5,
      text: "Lost my passport the week before a trip to London. Fast Passport Center replaced it in 48 hours. As a border community resident, I really appreciated not having to drive 90+ minutes to Seattle.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "bel-1",
      name: "Bellingham Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 Prospect St",
      city: "Bellingham",
      state: "WA",
      zip: "98225",
      phone: "(360) 734-4802",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Bellingham, near the Central Business District",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bellingham acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Bellingham, WWU, and Fairhaven.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-2",
      name: "Birch Bay Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8080 Birch Bay Dr",
      city: "Blaine",
      state: "WA",
      zip: "98230",
      phone: "(360) 371-2044",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Birch Bay, approximately 15 miles north of Bellingham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Birch Bay, Blaine, and north Whatcom County residents. Good alternative for border community travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-3",
      name: "Ferndale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5617 3rd Ave",
      city: "Ferndale",
      state: "WA",
      zip: "98248",
      phone: "(360) 384-1561",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ferndale, approximately 7 miles north of downtown Bellingham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ferndale and north Whatcom County. Good alternative for north-county residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-4",
      name: "Mount Vernon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 S 3rd St",
      city: "Mount Vernon",
      state: "WA",
      zip: "98273",
      phone: "(360) 336-2291",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mount Vernon, approximately 25 miles south of Bellingham via I-5",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mount Vernon, Burlington, and Skagit County. Good alternative for south Whatcom County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-5",
      name: "Whatcom County Auditor",
      type: "County Auditor Passport Acceptance",
      address: "311 Grand Ave, Suite 103",
      city: "Bellingham",
      state: "WA",
      zip: "98225",
      phone: "(360) 778-5104",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Downtown Bellingham Whatcom County Courthouse",
      website: "https://www.whatcomcounty.us/",
      websiteLabel: "Whatcom County",
      notes: "Whatcom County Auditor passport acceptance. Extended hours compared to post office. Convenient to downtown Bellingham. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 90+ minute I-5 drive to Seattle", fpc: "No — ship from Bellingham" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Border & WWU Advantage", agency: "No special guidance", fpc: "Yes — border community and student travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Bellingham WWU students and border residents often discover passport issues just before study abroad programs or international trips. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Meridian Street or at Bellis Fair Mall sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Whatcom County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Bellingham Post Office appointments fill during WWU semester breaks and summer travel peaks. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the 90-Minute Drive to Seattle",
      description: "Bellingham residents attempting to reach the Seattle passport agency face a 90+ minute drive each way on I-5. Between fuel costs, Seattle parking, and lost time, this can become a full-day commitment — our courier service eliminates all of that.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. WWU study abroad deadlines and summer travel to Canada both peak during May–August — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Bellingham area or Whatcom County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Bellingham, Ferndale, or Lynden." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need for a 90-minute I-5 drive yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bellingham address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Bellingham, WA?", a: "Fast Passport Center offers emergency passport processing in Bellingham, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 90 minutes south via I-5." },
    { q: "Does Bellingham have its own passport agency?", a: "No — Bellingham does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 90 minutes south via I-5). Fast Passport Center's courier service means Bellingham residents never need to make the long drive to Seattle." },
    { q: "Can I get an expedited passport in Ferndale, Lynden, or Blaine?", a: "Absolutely. Fast Passport Center serves all of Whatcom County including Ferndale, Lynden, Blaine, Birch Bay, Everson, Nooksack, Sumas, and Point Roberts. Our service works the same way everywhere." },
    { q: "What airport do Bellingham travelers use for international flights?", a: "Bellingham International Airport (BLI) offers convenient seasonal flights via Alaska Airlines with connections through Seattle. For most international travel, Seattle-Tacoma International Airport (SEA) is the primary gateway — approximately 90 minutes south via I-5. Vancouver International Airport (YVR) in British Columbia is also an option for Bellingham border residents." },
    { q: "Does Fast Passport Center serve Western Washington University students?", a: "Yes. Fast Passport Center serves all of Bellingham including WWU students and faculty. We understand student study abroad deadlines and can accommodate urgent passports for academic programs. Our courier service is ideal for students who can't take a day off to drive to Seattle." },
    { q: "How much does an expedited passport cost in Bellingham, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Bellingham?", a: "Walgreens, CVS, and Rite Aid stores throughout Bellingham offer passport photos. UPS Store and FedEx Office locations also provide them. Locations on Meridian Street, Bakerview Road, and at Bellis Fair Mall offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Peace Arch border community?", a: "Yes. Fast Passport Center serves all of Whatcom County including the Peace Arch border community in Blaine and the Sumas border crossing. We understand the unique needs of border residents who frequently cross between Washington and British Columbia. While enhanced driver's licenses work for land crossings, a passport book is required for all air travel to Canada." },
  ],
  photoLocations: [
    { name: "Walgreens — Meridian Street", address: "2900 Meridian St, Bellingham, WA 98225", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Rite Aid — Bakerview Road", address: "4130 Meridian St, Bellingham, WA 98226", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "UPS Store — Downtown Bellingham", address: "1200 10th St, Bellingham, WA 98225", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Bellingham", address: "1225 E Sunset Dr, Bellingham, WA 98226", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "WA DOL — Bellingham", address: "4180 Meridian St, Bellingham, WA 98226", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Mount Vernon", address: "1000 Fountain St, Mount Vernon, WA 98273", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Skagit County. Alternative for south Whatcom County residents. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "BLI",
      name: "Bellingham International Airport",
      distance: "10 minutes from downtown Bellingham",
      address: "4255 Mitchell Way, Bellingham, WA 98226",
      note: "Bellingham's own airport with seasonal flights via Alaska Airlines. Convenient connections through SEA. Serves Whatcom County and Lower Mainland BC travelers. Free parking and short security lines make BLI a preferred choice for local flyers.",
      flightUrl: "https://www.portofbellingham.com/",
      flightLabel: "BLI Flight Info",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "90 minutes south of Bellingham via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary international airport for Whatcom County travelers. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: false,
    },
    {
      code: "YVR",
      name: "Vancouver International Airport (BC)",
      distance: "Approximately 60 minutes north of Bellingham via I-5/BC-99",
      address: "3211 Grant McConachie Way, Richmond, BC, Canada",
      note: "Major international airport in Vancouver, British Columbia — an option for Bellingham border residents. Nonstop flights to Asia, Europe, and across Canada. Requires valid passport to access.",
      flightUrl: "https://www.yvr.ca/",
      flightLabel: "YVR Flight Info",
      featured: false,
    },
  ],
};